import React from 'react';
import { useRecoilValue } from 'recoil';
import { displayCocoonState } from 'features/file-browser/state/fileAtoms';
import { isVisibleCocoonState } from 'features/three-view/state/threeAtoms';
import { StlViewer } from '../utils/stlViewer';

export const CocoonViewer: React.FC = () => {
  const displayCocoon = useRecoilValue(displayCocoonState);
  const isVisibleCocoon = useRecoilValue(isVisibleCocoonState);

  if (!displayCocoon || !isVisibleCocoon) return <></>;

  const url = displayCocoon.url;
  const name = displayCocoon.name.split('.').slice(0, -1).join('.');

  return <StlViewer
    url={url}
    name={name}
    defaultColor={'#ff0000'}
    label={'Cocoon'}
  />;
};
